<template>
  <div class="no-data-note" :style="{background: background}">
    <div class="icon" v-if="type === 1 || type === 2">
      <img src="@/assets/images/nodata.png" alt />
    </div>
    <div class="note" v-if="type === 0 || type === 2">
      <p>{{ note }}</p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    background: {
      type: String,
      default: "#ffffff"
    },
    type: {
      type: Number,
      default: 0 // 0 文字 1 图 2 图文
    },
    note: {
      type: String,
      default: "文案文案"
    }
  }
};
</script>

<style lang="less" scoped>
  .no-data-note {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    .icon {
      margin-top: 80px;
      width: 130px;
      height: 120px;

      img {
        width: 100%;
        height: 100%;
        display: block;
      }
    }
    .note {
      margin-top: 40px;
      p {
        font-size: 12px;
        color: #999999;
      }
    }
  }
</style>